import APIClient from '@/shared/http/clients/api'

const resourceName = 'consulta-serasa'
const APICore = process.env.APIBaseURLCore

const ConsultBureau = (document, config = {}) => APIClient.get(`${APICore}/${resourceName}/credit-bureau/${document}`, config)
const Relato = (document, config = {}) => APIClient.get(`${APICore}/${resourceName}/relato/${document}`, config)

const consultaSerasa = {
  ConsultBureau,
  Relato
}

export default consultaSerasa



// WEBPACK FOOTER //
// ./src/shared/http/repositories/serasa/consultaSerasa.js